module.exports = __webpack_public_path__ + "static/img/authhistory.d119045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/app/authhistory.jpg
// module id = 2XSr
// module chunks = 0